import React, { useMemo, useState, useCallback } from "react";
import { useIntl } from "react-intl";
import { TableChangeParams } from "../types";
import Foot from "../Foot";

type TableFooterProps = {
  initialParams?: TableChangeParams | null;
  onChange?: (changeParams: TableChangeParams) => void;
  paginationTotal: number;
  paginationLimit: number;
  limitChoiceEnabled?: boolean;
  setLoading?: (loading: boolean) => void;
};

const TableFooter = ({
  initialParams: tableInitialParams,
  onChange,
  paginationTotal,
  paginationLimit,
  limitChoiceEnabled,
  setLoading,
}: TableFooterProps): JSX.Element => {
  const intl = useIntl();

  const initialParams = useMemo<TableChangeParams>(
    () => ({
      pageIndex: 0,
      type: "",
      filters: [],
      limit: paginationLimit,
      ...tableInitialParams,
    }),
    [paginationLimit, tableInitialParams]
  );

  const [changeParams, setChangeParams] =
    useState<TableChangeParams>(initialParams);

  const handlePageChange = useCallback(
    (page: number) => {
      const newParams = { ...changeParams, pageIndex: page };
      setChangeParams(newParams);
      setLoading?.(true);
      onChange?.(newParams);
    },
    [changeParams, onChange, setLoading]
  );

  const handleLimitChange = useCallback(
    (newLimit: number) => {
      const newParams = { ...changeParams, pageIndex: 0, limit: newLimit };
      setChangeParams(newParams);
      setLoading?.(true);
      onChange?.(newParams);
    },
    [changeParams, onChange, setLoading]
  );

  const { pageIndex, limit } = changeParams;

  return (
    <Foot
      total={paginationTotal}
      limit={limit}
      forcePage={pageIndex}
      onPageChange={handlePageChange}
      limitChoiceEnabled={limitChoiceEnabled}
      onLimitChange={handleLimitChange}
      intl={intl}
      className="pb-10"
    />
  );
};

export default TableFooter;
